<template>
  <div class="paypal-monitor">
    <tooltipLine :visible="true" :content="$t('paypal::monitor::header_tip')" :showClose="false">
      <div slot="btn">
        <span
          class="bind-btn"
          @click="$router.push({ name: 'paypal', query: { type: '1' } })"
          v-if="!($store.state.user.hasBindData && $store.state.user.hasBindData.isExistPaypalSet)"
        >
          {{ $t('paypal::monitor::绑定PayPal账户') }}
        </span>
      </div>
    </tooltipLine>
    <div class="search">
      <el-form inline>
        <el-form-item :label="$t('paypal::monitor::PayPal账户')">
          <el-select
            style="width: 180px"
            v-model="params.accountId"
            clearable
            filterable
            :placeholder="'请选择PayPal账户'"
            @change="search"
            :popper-append-to-body="false"
          >
            <el-option
              v-for="(item, index) in accountList"
              :key="index"
              :label="item.accountName"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('paypal::monitor::店铺名称')">
          <el-select
            style="width: 180px"
            v-model="params.shopId"
            clearable
            filterable
            :placeholder="'请选择店铺'"
            @change="search"
            :popper-append-to-body="false"
          >
            <el-option
              v-for="(item, index) in shopList"
              :key="index"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('paypal::monitor::日期')">
          <el-date-picker
            style="width: 180px"
            :appendToBody="false"
            :clearable="false"
            format="yyyy-MM-dd"
            @change="handlerDateChange"
            class="day-item"
            type="date"
            unlink-panels
            v-model="params.dayTime"
          ></el-date-picker>
        </el-form-item>
      </el-form>
      <span class="header-tip">{{ $t('paypal::monitor::tip') }}</span>
    </div>

    <el-row :gutter="16">
      <el-col :lg="15" :md="15" :sm="15" :xl="15">
        <el-row type="flex" justify="space-between" :gutter="16">
          <el-col v-for="(item, index) in cardOptions" :key="index">
            <dataCard active="" :option="item" v-loading="loading"></dataCard>
          </el-col>
        </el-row>
      </el-col>
      <el-col :lg="9" :md="9" :sm="9" :xl="9">
        <el-card
          class="account-overview"
          body-style="display: flex;align-items: center;justify-content:center;width:100%;"
        >
          <div
            class="account-overview-item"
            @click="changeTab(item)"
            v-loading="loading"
            v-for="(item, index) in accountCards"
            :key="index"
            :style="{ cursor: item.type ? 'pointer' : 'default' }"
          >
            <div class="account-header">
              <span class="account-header-title">{{ item.title }}</span>
              <el-tooltip v-show="item.tooltip" placement="top">
                <div slot="content">
                  {{ item.tooltip }}
                  <el-button
                    style="padding: 0; font-size: 12px"
                    @click="item.btnFn()"
                    type="text"
                    v-show="item.btnText"
                  >
                    {{ item.btnText }}
                  </el-button>
                </div>
                <i class="icon-a-01wenhao iconfont-el"></i>
              </el-tooltip>
            </div>
            <div class="account-content">
              <span class="account-content-num">{{ item.num }}</span>
              <span class="account-content-unit">{{ item.unit }}</span>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <el-card style="margin-top: 16px; position: relative">
      <el-tabs v-model="activeTab">
        <template v-for="(item, index) in tabs">
          <el-tab-pane :label="item.label" :name="item.name" :key="index"></el-tab-pane>
        </template>
      </el-tabs>
      <div class="handle-btns">
        <i class="iconfont icona-03shezhi" @click="showEditHeader = true"></i>
        <i class="iconfont iconicon_Import" @click="download"></i>
      </div>
      <z-table
        ref="table"
        v-loading="tableLoading"
        :data="tableData"
        :height="420"
        :pagination.sync="pagination"
        :columns="newColumns"
        @page-change="getTableList"
        @sort-change="sortChange"
        showHeader
        class="table-fixed"
      >
        <!-- 动态表头比数据渲染慢时，表格会出现留白情况，所以写死表头高度 -->
        <template #accountName="{ row }">
          <span>{{ row.accountName }}</span>
          <div v-show="row.warnStatus == 1" class="warning-tag">预警</div>
        </template>
        <template #shopList="{ row }">
          <span>{{ row.shopList && row.shopList.map(el => el.shopName).join('、') }}</span>
        </template>
        <template #status="{ row }">
          <span :style="{ color: row.status == '不可收款账户' && activeTab == 1 ? '#F93000' : '' }">
            {{ $dataCheck(row.status, '--') }}
          </span>
          <el-tooltip placement="right">
            <div slot="content">状态异常时间：{{ row.nonReceivableTime }}</div>
            <i
              style="color: #f93000; font-size: 14px"
              class="iconquestion-circle-o iconfont"
              v-show="row.status == '不可收款账户' && activeTab == 1"
            ></i>
          </el-tooltip>
        </template>
        <template #totalBalance="{ row }">
          <el-popover placement="bottom-start" @show="showDetail(row, 'total_balance')" trigger="hover">
            <div class="sum-container">
              <div class="sum-title">{{ $t('paypal::monitor::总余额明细') }}</div>
              <div class="sum-content" v-loading="detailLoading">
                <div class="sum-item" v-for="(item, index) in detail" :key="index">
                  <span>{{ item.currency }}</span>
                  <div class="link"></div>
                  <span>$ {{ $dataCheck(formatNumberMix(item.balance, 2, ','), '--') }}</span>
                </div>
              </div>
            </div>
            <!-- <el-link :underline="false" type="primary" slot="reference">{{ row.sum }}</el-link> -->
            <span slot="reference" class="sum">
              {{ '$' + $dataCheck(formatNumberMix(row.totalBalance, 2, ','), '--') }}
            </span>
          </el-popover>
        </template>
        <template #withheldBalance="{ row }">
          <el-popover placement="bottom-start" @show="showDetail(row, 'withheld_balance')" trigger="hover">
            <div class="sum-container">
              <div class="sum-title">{{ $t('paypal::monitor::冻结余额明细') }}</div>
              <div class="sum-content" v-loading="detailLoading">
                <div class="sum-item" v-for="(item, index) in detail" :key="index">
                  <span>{{ item.currency }}</span>
                  <div class="link"></div>
                  <span>$ {{ $dataCheck(formatNumberMix(item.balance, 2, ','), '--') }}</span>
                </div>
              </div>
            </div>
            <!-- <el-link :underline="false" type="primary" slot="reference">{{ row.sum }}</el-link> -->
            <span slot="reference" class="sum">
              {{ '$' + $dataCheck(formatNumberMix(row.withheldBalance, 2, ','), '--') }}
            </span>
          </el-popover>
        </template>
        <template #availableBalance="{ row }">
          <el-popover placement="bottom-start" @show="showDetail(row, 'available_balance')" trigger="hover">
            <div class="sum-container">
              <div class="sum-title">{{ $t('paypal::monitor::可提现余额明细') }}</div>
              <div class="sum-content" v-loading="detailLoading">
                <div class="sum-item" v-for="(item, index) in detail" :key="index">
                  <span>{{ item.currency }}</span>
                  <div class="link"></div>
                  <span>$ {{ $dataCheck(formatNumberMix(item.balance, 2, ','), '--') }}</span>
                </div>
              </div>
            </div>
            <!-- <el-link :underline="false" type="primary" slot="reference">{{ row.sum }}</el-link> -->
            <span slot="reference" class="sum">
              {{ '$' + $dataCheck(formatNumberMix(row.availableBalance, 2, ','), '--') }}
            </span>
          </el-popover>
        </template>
        <template #empty>
          <ZDefaultData></ZDefaultData>
        </template>
      </z-table>
    </el-card>
    <EditHeader
      v-model="showEditHeader"
      :list="editColumns"
      :columns="columns"
      :info="editInfo"
      @change="changeTableColumns"
    ></EditHeader>
  </div>
</template>

<script>
import { getPaypalList, getPaypalOverview, getPaypalDetailList, getPaypalDetail } from '@/server/paypal'
import { templateDownload } from '@/server/etl'
import setConfig from './setConfig'
import { getCookie } from '@/utils/utils'
import moment from 'moment'
import dataCard from '@/components/data-analysis/newCard/index.vue'
import { formatNumberMix } from '@/utils'
import EditHeader from '@/views/operate-analysis/day-report/components/edit-header/index.vue'
import { getColumnConfig } from '@/server/common'
import ZDefaultData from '@/components/common/default-data/main'
export default {
  components: { dataCard, EditHeader, ZDefaultData },
  mixins: [setConfig],
  data() {
    return {
      params: {
        shopId: '',
        accountId: '',
        dayTime: moment().format('YYYY-MM-DD'),
        orgUnitId: this.$store.state.user.merchantId,
        type: '',
        sortType: '',
        sortColumn: '',
      },
      accountList: [],
      cardOptions: [],
      accountCards: [],
      loading: false,
      tableLoading: false,
      detailLoading: false,
      showEditHeader: false,
      detail: [],
      pagination: {
        pageNum: 1,
        pageSize: 10,
        total: 0,
      },
      tabs: [
        { label: this.$t('paypal::monitor::全部账户'), name: '1' },
        { label: this.$t('paypal::monitor::正常账户'), name: '2' },
        { label: this.$t('paypal::monitor::不可收款账户'), name: '4' },
        { label: this.$t('paypal::monitor::预警账户'), name: '3' },
      ],
      statusList: {
        1: '全部账户',
        2: '正常账户',
        4: '不可收款账户',
        3: '预警账户',
      },
      activeTab: '1',
      tableData: [],
      defaultColumns: [
        {
          label: this.$t('paypal::monitor::PayPal账户'),
          prop: 'accountName',
          minWidth: 300,
          sortable: 'custom',
        },
        {
          prop: 'shopNameList',
          label: this.$t('paypal::monitor::店铺'),
          minWidth: 150,
          sortable: 'custom',
        },
        {
          prop: 'company',
          label: this.$t('paypal::monitor::企业名称'),
          minWidth: 200,
          sortable: 'custom',
        },
        {
          prop: 'totalBalance',
          label: this.$t('paypal::monitor::总余额'),
          minWidth: 150,
          sortable: 'custom',
        },
        {
          prop: 'withheldBalance',
          label: this.$t('paypal::monitor::冻结余额'),
          minWidth: 150,
          sortable: 'custom',
        },
        {
          prop: 'availableBalance',
          label: this.$t('paypal::monitor::可提现余额'),
          minWidth: 150,
          sortable: 'custom',
        },
        {
          prop: 'status',
          label: this.$t('paypal::monitor::状态'),
          minWidth: 150,
          sortable: 'custom',
        },
        {
          prop: 'managerName',
          label: this.$t('paypal::monitor::有客户经理'),
          minWidth: 150,
        },
      ],
      editColumns: [],
      editInfo: {
        name: 'paypal全部账户',
        limit: 4,
      },
    }
  },
  computed: {
    columns() {
      // 当前表格的表头
      let list = [...this.defaultColumns]
      if (this.activeTab == 4) {
        list.splice(-1, 0, {
          prop: 'nonReceivableTime',
          label: this.$t('paypal::monitor::不可收款时间'),
          minWidth: 200,
          sortable: 'custom',
        })
      } else if (this.activeTab == 3) {
        list.splice(
          1,
          0,
          {
            prop: 'warnTime',
            label: this.$t('paypal::monitor::预警时间'),
            minWidth: 200,
            sortable: 'custom',
          },
          {
            prop: 'warnReason',
            label: this.$t('paypal::monitor::预警原因'),
            minWidth: 200,
            sortable: 'custom',
          }
        )
      }
      return list
    },
    merchantId() {
      return this.$store.state.user.merchantId
    },
    shopList() {
      return [{ label: this.$t('system::common::select_all_shop'), value: '' }, ...this.$store.state.products.shopList]
    },
    newColumns() {
      // 编辑后表头
      let list = this.editColumns.length ? this.editColumns.filter(el => el.active) : this.columns
      return list
    },
  },
  watch: {
    async activeTab(val) {
      this.params.type = val
      switch (val) {
        case '1':
          this.editInfo.name = 'paypal全部账户'
          break
        case '2':
          this.editInfo.name = 'paypal正常账户'
          break
        case '4':
          this.editInfo.name = 'paypal不可收款账户'
          break
        case '3':
          this.editInfo.name = 'paypal预警账户'
          break
      }
      // 清空筛选
      this.$refs.table.$refs.elTable.clearSort()
      this.$refs.table.$refs.elTable.doLayout()
      this.params.sortColumn = ''
      this.params.sortType = ''
      await this.getColumnConfig()
      this.$nextTick(() => {
        this.getTableList(true)
      })
    },
  },
  async mounted() {
    this.$store.dispatch('getShopList')
    this.getPaypalList()
    if (this.$route.query.type) {
      this.activeTab = this.$route.query.type
    }
    this.cardOptions = this.setCardOptions({})
    this.accountCards = this.setAccountCards({})
    await this.getColumnConfig()
    this.getAllData()
  },
  methods: {
    formatNumberMix,
    async getPaypalList() {
      let params = {
        pageNum: 1,
        pageSize: 10000,
      }
      let { data } = await getPaypalList({ ...params })
      if (data.code === this.$code) {
        this.accountList = data.data.items || []
      }
    },
    changeTab(item) {
      if (item.type) {
        this.activeTab = item.type
      }
    },
    handlerDateChange(date) {
      this.params.dayTime = moment(date).format('YYYY-MM-DD')
      this.search()
    },
    getAllData() {
      this.getPaypalOverview()
      this.getTableList()
    },
    search() {
      this.pagination.pageNum = 1
      this.getAllData()
    },
    async getTableList(init) {
      init && (this.pagination.pageNum = 1)
      let params = {
        ...this.pagination,
        ...this.params,
      }
      if (this.activeTab !== '1') {
        params.status = this.statusList[this.activeTab]
      }
      params = this.clearEmptyProperty(params)
      this.tableLoading = true
      this.tableData = []
      const { data } = await getPaypalDetailList(params)
      this.tableLoading = false
      if (data.code === this.$code) {
        this.tableData = data.data.datas || []
        this.pagination.total = data.data.totalSize
      }
    },
    async getPaypalOverview() {
      this.loading = true
      let params = {
        ...this.params,
      }
      params = this.clearEmptyProperty(params)
      const { data } = await getPaypalOverview(params)
      this.loading = false
      if (data.code === this.$code) {
        this.cardOptions = this.setCardOptions(data.data.datas.length ? data.data.datas[0] : {})
        this.accountCards = this.setAccountCards(data.data.datas.length ? data.data.datas[0] : {})
      }
    },
    async showDetail(item, type) {
      this.detailLoading = true
      this.detail = []
      let params = {
        ...this.params,
        accountId: item.accountId,
        balanceType: type,
      }
      params = this.clearEmptyProperty(params)
      const { data } = await getPaypalDetail(params)
      this.detailLoading = false
      if (data.code === this.$code) {
        this.detail = data.data.datas || []
      }
    },
    sortChange(data) {
      if (data.order) {
        this.params.sortType = data.order == 'ascending' ? 'ASC' : 'DESC'
        this.params.sortColumn = data.prop.replace(/([A-Z])/g, '_$1').toLowerCase()
      } else {
        this.params.sortType = ''
        this.params.sortColumn = ''
      }
      this.getTableList(true)
    },
    toEdit() {
      this.showEditHeader = true
    },
    // 获取表头配置
    async getColumnConfig() {
      let list = []
      const { data } = await getColumnConfig({ tableName: this.editInfo.name })
      if (data.code === this.$code) {
        const obj = data.data || {}
        if (obj.columns) {
          list = JSON.parse(obj.columns)
        }
      }
      // 确保表头是最新的
      // 如有新增列则默认勾选表头
      this.columns.forEach(el => {
        if (list.every(item => !item.prop || item.prop !== el.prop)) {
          list.push({ prop: el.prop, label: el.label, active: true })
        }
      })
      this.editColumns = list
    },
    changeTableColumns(info) {
      this.editColumns = info.list
      // 更换表头后清空排序
      this.params.sortType = ''
      this.params.sortColumn = ''
      this.$refs.table.$refs.elTable.clearSort()
      this.getTableList(true)
    },
    async download() {
      if (!this.tableData.length) {
        this.$message.warning(this.$t('paypal::monitor::download_tip'))
        return
      }
      let params = {
        ...this.params,
        ...this.pagination,
        pageSize: 20000,
      }
      let name = ''
      if (this.activeTab !== '1') {
        params.status = this.statusList[this.activeTab]
      }
      name = `paypal${this.statusList[this.activeTab]}清单`
      params = this.clearEmptyProperty(params)
      const { data } = await templateDownload(
        'load.shoplus.bi.paypal.detail.download',
        params,
        name + moment().format('YYYYMMDD'),
        getCookie('saasToken')
      )
    },
    clearEmptyProperty(obj) {
      for (let key in obj) {
        if (!obj[key]) {
          delete obj[key]
        }
      }
      return { ...obj }
    },
  },
}
</script>

<style lang="scss" scoped>
.handle-btns {
  position: absolute;
  top: 24px;
  right: 16px;
  .iconfont {
    font-size: 18px;
    color: #999;
    cursor: pointer;
  }
  .iconfont + .iconfont {
    margin-left: 12px;
  }
}
.search {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.header-tip {
  color: #999;
  font-size: 14px;
  margin-bottom: 22px;
}
.paypal-monitor {
  .overview {
    display: flex;
  }
  .account-overview {
    display: flex;
    align-items: center;
    width: 100%;
    .account-overview-item {
      margin: 25px 0 26px;
      padding-left: 15px;
      width: 50%;
      display: flex;
      flex-direction: column;
      .account-header {
        font-size: 12px;
        color: #999;
        display: flex;
        align-items: center;
        .iconfont {
          font-size: 12px;
          margin-left: 4px;
        }
      }
      .account-content {
        margin-top: 12px;
        .account-content-num {
          font-size: 24px;
          color: #366dff;
          margin-right: 6px;
          font-weight: bold;
        }
        .account-content-unit {
          font-size: 14px;
          color: #1b223c;
        }
      }
    }
    .account-overview-item + .account-overview-item {
      border-left: 1px solid #ebebeb;
    }
  }
}
.sum-container {
  .sum-title {
    font-size: 12px;
    margin-bottom: 8px;
  }
  .sum-content {
    width: 273px;
    padding: 16px;
    background: #f7f8f9;
    border-radius: 4px;
    min-height: 16px;
    .sum-item {
      display: flex;
      font-size: 12px;
      color: #262626;
      align-items: center;
      .link {
        flex: 1;
        border-top: 1px dashed #cfcfcf;
        margin: 0 8px;
      }
    }
    .sum-item + .sum-item {
      margin-top: 16px;
    }
  }
}
.sum {
  color: #366dff;
  cursor: pointer;
}
.warning-tag {
  border-radius: 2px;
  border: 1px solid #f93000;
  padding: 2px 0;
  color: #f93000;
  width: 36px;
  font-size: 12px;
  text-align: center;
  line-height: 1;
}
.table-fixed {
  /deep/.el-table__body-wrapper {
    height: calc(100% - 42px) !important;
  }
}
</style>
